import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

type SpacerProps = React.HTMLAttributes<HTMLDivElement>

const Spacer: React.FC<SpacerProps> = ({ className, ...props }) => {
  const classes = useStyles()

  return <div className={clsx(classes.root, className)} {...props} />
}

export default Spacer
